import axios from "axios";



const clienteAxios = axios.create({
    baseURL: '/api/'
    //baseURL: 'http://localhost:7001/api/'
})


export default clienteAxios;